import { useEffect, useLayoutEffect, useState } from 'react';
import { useMatch, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AgentEmptyIcon, AgentLogoIcon } from '@/components/agent/assets';
import { cn } from '@/lib/utils';
import { agentManager, agentsHooks } from '@/manager/manager/agent-manager';
import { Image } from '@/components/common/image';
import { TruncatedText } from '@/components/common/truncated-text';
import { useRouteNavigateHook } from '@/manager';
import { Tooltip } from '../ui/modal';
import { CreationIcon } from '../agent-creation/assets/creation-icon';

// 骨架屏容器组件
function Skeleton() {
  return (
    <div className="space-y-3">
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className='w-60 h-7 flex items-center px-4 py-2 rounded-sm transition-colors animate-pulse'>
          <div className="flex-1 h-7 bg-gray-200 animate-pulse rounded-md"></div>
        </div>
      ))}
    </div>
  );
}

/** 智能体侧边栏 */
export const AgentSidebar = ({
  collapsed = false,
}: {
  collapsed?: boolean;
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { navigate } = useRouteNavigateHook.useNavigate();

  // 只有在访问agent路由时才执行相关逻辑
  const isAgentRoute = useMatch('/agent/*');
  // const { agents, loading } = agentsHooks.useAgentData();

  const handleCreationClick = () => {
    // if (loading) return
    const storedId = agentManager.getAgentId();
    if (storedId) {
      navigate(`/agent/creation/${storedId}/`);
    }
  };

  return (
    <section className={cn(
      "w-full flex flex-col transition-all duration-200 mt-2",
    )}>
      <div
        className={cn(
          "h-full space-y-0.5",
          collapsed && "flex flex-col items-center"
        )}
      >
        <div
          onClick={handleCreationClick}
          className={cn(
            "flex items-center px-[10px] py-2 rounded-[6px] hover:bg-[rgba(16,24,40,0.05)] cursor-pointer transition-colors",
            collapsed && "justify-center size-9",
            isAgentRoute && 'bg-[rgba(16,24,40,0.05)]'

          )}>
          <Tooltip
            side='right'
            align='center'
            offset={25}
            trigger={
              <div><CreationIcon className='size-5 text-[rgba(13,13,13,1)] flex-shrink-0' /></div>
            }
            content={
              collapsed && (
                <div className="relative max-w-[384px] w-max bg-[rgba(16,24,40,1)] px-3 py-2 rounded-[8px]">
                  <span className="block max-w-[384px] text-[rgba(255,255,255,1)] text-sm whitespace-nowrap">
                    {t('agent.agent_sidebar.creation')}
                  </span>
                </div>
              )
            }
          />
          {!collapsed && <span className='ml-[10px] text-sm text-[#0D0D0D] whitespace-nowrap'>{t('agent.agent_sidebar.creation')}</span>}
        </div>
        {/* {(!loading && agents?.length) ? agents?.map((agent) => (
          <div
            key={agent?.id}
            onClick={() => handleAgentClick(agent.id)}
            className={cn(
              "flex items-center px-2 py-1.5 rounded-[6px] hover:bg-[rgba(16,24,40,0.05)] cursor-pointer transition-colors",
              collapsed && "p-1 justify-center",
              agent.id === activeAgentId && 'bg-[rgba(16,24,40,0.05)]'
            )}>
            <div className={`w-6 h-6 rounded-full flex items-center justify-center`}>
              <Tooltip
                side='right'
                align='center'
                offset={25}
                trigger={
                  <Image src={agent?.avatar} className="w-6 h-6 rounded-full object-cover flex-shrink-0" />
                }
                content={
                  collapsed && (
                    <div className="relative max-w-[384px] w-max bg-[rgba(16,24,40,1)] px-3 py-2 rounded-[8px]">
                      <span className="block max-w-[384px] text-[rgba(255,255,255,1)] text-sm whitespace-nowrap">
                        {agent?.name}
                      </span>
                    </div>
                  )
                }
              />

            </div>
            {!collapsed && <TruncatedText text={agent?.name} className='ml-2 w-[80%] text-sm text-[#0D0D0D]' />}
          </div>
        )) : (!loading && !collapsed) && (
          <div className='flex flex-col items-center justify-center gap-3 flex-1 h-88'>
            <AgentEmptyIcon className={cn(collapsed && "size-6")} />
            <span className='text-sm text-[rgba(102,112,133,1)]'>{t('agent.agent_sidebar.agent_empty_tips')}</span>
          </div>
        )} */}
      </div>
    </section >
  )
}